import React, { useEffect, useState, useRef } from 'react'
import useApp from 'hooks/useApp'
import Lib from 'library'
import {  useNavigate } from 'react-router-dom'
import { Button, NoData, Logo, CommonAgreeLayer } from 'components'
import styles from './index.module.css'
import Native from 'library/native'

const ThinkInfo = () => {

	const App = useApp()
	const navigate = useNavigate()

	const [mydataResultYn, setMydataResultYn] = useState(); // 마이데이터 진행여부
	const [mbStockInsttProdList, setMbStockInsttProdList] = useState(); // 회원별 증권사별 목록
	
	const [tremsShow, setTremsShow] = useState(false); // 약관동의 바텀시트
	

	const mounted = useRef()

	useEffect(() => {
		mounted.current = true

		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: undefined,
		})

		App.setShowNav(false)
		App.setMainClass("white")

		mounted && mydataJobCheck(); // 마이데이터 작업중인지 확인

		return () => {
			mounted.current = false
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	// 1 마이데이터 작업중인지 확인 
	const mydataJobCheck = () => {
		App.showLoading();
		Lib.post("/api/inner/thinkpool/mb/mydata/jobyn", data => {
			if (data && data.resultYn) {
				setMydataResultYn(data.resultYn);
			}
			if(data.resultYn !== 'Y'){
				getValid();
			}
			App.hideLoading();
		})
	}
	// 2. 증권업권 연동여부 및 약관동의 여부 확인
	const getValid = () => {
		App.showLoading();
		// 시작 하기 버튼 클릭 시 하기 내용 확인 해야함
		// /api/inner/thinkpool/mb/valid 호출하여 증권 업권 연동 여부 및 약관 동의 여부 확인
		// 	// 1. 마이데이터 연결되어 있는지 확인
		Lib.post("/api/inner/thinkpool/mb/valid", data => {
			if(data.lnkupInvestYn === 'N'){
			// 1-N-1. 증권없음 알럿노출
				// : 결과 값(lnkupInvestYn) 이 'N' 일 경우 증권 업권 연동 해야 함
				App.alert("연결된 증권이 없습니다<br/>마이데이터 연결 화면으로<br/>이동합니다.", () => {
					// 1-N-2. 알럿 닫히면 마이데이터 연결 페이지로 이동
					goMydata()
				})
			}else if(data.termsAgreeYn === 'N'){
			// 1-Y-1. 약관동의 확인
				// : 결과 값(termsAgreeYn) 이 'N' 일 경우 약관 동의 받아야 함
				// 1-Y-1-N-1 약관리스트 바텀시트 노출
				setTremsShow(true)
			}else if(data.lnkupInvestYn === 'Y' && data.termsAgreeYn === 'Y'){
				// 위 결과 값이 모두 Y 일 경우 다음 프로세스 진행
				getStockInsttProdList(); // 회원별 증권사(기관)별 상품목록 조회
			}
			App.hideLoading();
		})
	}

	// 회원별 증권사(기관)별 상품목록 조회
	const getStockInsttProdList = () => {
		Lib.post("/api/inner/thinkpool/mb/stock/instt/item/list", data => {
			setMbStockInsttProdList(data);
		})
	}

	// 약관동의 처리
	const onTremsAgree = () => {
		// 약관동의 처리가 되어야만 증권 씽크폴 페이지 이동가능함
		setTremsShow(false)
		getStockInsttProdList(); // 회원별 증권사(기관)별 상품목록 조회
	}

	// 마이데이터 페이지로 이동
	const goMydata = () => {
		navigate("/data", {
			state: {
				preIndstCd: "INVEST",
				from: "/mydata"
			}
		});
	}

	// 분석결과보기 클릭
	const goAnalysResult = () => {
		// Lib.post("/api/inner/thinkpool/mb/prod/pay/list", {}, data => {
		Lib.post("/api/inner/thinkpool/payInfo", data => {
			if (data && data.payYn === "Y") { // 씽크풀로 이동 (결제여부)
				console.log("씽크풀로 이동")
				let url = App.thinkPoolServer + "?mbId=" + window.localStorage.getItem("mbId") + "&fromType=useGuide";
				console.log("url", url);
				Native.execute("Popup", "openPopup", undefined, { url: url, fullscreen: "Y", backPress: "Y" })
			} else { // 상품결제페이지로 이동
				console.log("상품결제로 이동")
				navigate("/thinkpool/thinkPayBefore")
			}
		})
	}

	// 홈으로 이동하기
	const goHome = () => {
		navigate("/");
	}

	return (
		<div className="page">
			<div className="flex_1 padding">
				<div className={styles.title}>이용안내</div>
				<div className={`${styles.guide} mt_40`}>
					My Stock Manager는 고객님의 마이데이터 증권정보를 기반으로 AI가 보유 종목을 분석하여 알려줘요.
					정보를 최신으로 유지할 경우 더 정확한 AI분석결과를 확인 할 수 있어요.
				</div>

				<div className={`${styles["notice-box"]} mt_20`}>
					<p>유의사항</p>
					<ul className="mt_10">
						<li>- 데이터연동이 해제된 기관의 보유 종목 제외됩니다.</li>
						<li>- 마이데이터로 연동된 정보와 실제 증권정보는 다를 수 있습니다.</li>
						<li>- My Stock Manager에서 제공하는 AI분석결과는 투자 참고사항이며, 제공된 정보에 의한 투자 결과에 법적 책임을 지지 않습니다.</li>
					</ul>
				</div>

				{
					mydataResultYn && mydataResultYn === "Y" ?
						//    mydataResultYn && mydataResultYn !== "Y"  && mydataResultYn !== "N"?
						<>
							{/* type3. 마이데이터를 업데이트하고 있는 경우(비정기적 전송) */}
							<NoData textBtn={true} text={<>마이데이터를 최신 정보로 업데이트 중이에요.<br />업데이트 완료 후 다시 이용해주세요.</>} refreshOnClick={mydataJobCheck} />
						</>
						:
						<>
							{/* type1. 보유종목이 있을 때 리스트 */}
							{ mbStockInsttProdList && <ProdList listData={mbStockInsttProdList} /> }
						</>
				}
			</div>
			{
				mydataResultYn && mydataResultYn === "Y" ?
					<>
						{/* button type3. 마이데이터를 업데이트하고 있는 경우(비정기적 전송) */}
						<div className="flex-shrink_0 padding">
							<Button className="btn btn--big btn--dark" onClick={goHome}>홈으로 이동하기</Button>
						</div>
					</>
					:
					<>
						{/* button type1. 보유종목이 있을 때 버튼 */}
						{ mbStockInsttProdList &&  
						<div className="flex-shrink_0 btn-group padding">
							<Button className="btn btn--big btn--dark" onClick={goMydata}>업데이트 하러가기</Button>
							<Button className="btn btn--big ml_10" onClick={goAnalysResult}>분석결과 보기</Button>
						</div> }
					</>
			}
			<CommonAgreeLayer title="이용약관" show={tremsShow} closeLayer={() => setTremsShow(false)} onAgree={onTremsAgree} termsCategoryCd="STOCK" />
			{/* <ConfirmLayer show={tremsShow}/> */}
		</div>
	)
}

const ProdList = ({ listData }) => {
	return <> <div className={`${styles["sub-title"]} mt_40`}>증권 연동 정보</div>
	<ul className={styles["info-group"]}>
		{ listData.map((item, idx) => {
				return (
					<li key={idx}>
						<div className={styles.company}>
							<div className="flex-align_center">
								<div className="img-symbol img-box">
									<Logo code={item.insttCd} style={{ width: "100%", height: "100%" }} />
								</div>
								<p className="ellipsis ml_10" style={{ width: "14rem" }}>{item.insttNm}</p>
							</div>
							{
								item.updDt ?
									<span>{item.updDt} 업데이트</span>
									:
									""
							}
						</div>

						<div className={`${styles.detail} mt_20`}>
							<ul>
								{
									item.itemList.map((subItem, subIdx) => {
										return (
											<li key={subIdx}>
												<p className="ellipsis">{subItem.itemNm}</p>
												<span>{Lib.addComma(subItem.evalAmt)} 원 ({Lib.addComma(subItem.holdgCnt)}주)</span>
											</li>
										)
									})
								}
							</ul>
						</div>
					</li>
				)
			})
		}
	</ul>
	</>
}


export default ThinkInfo